<template>
    <div></div>
</template>

<script>
    import {i18n} from '../plugins/i18n.js'
    import TDSHead from '../components/TDSHead'
    import TDSFoot from '../components/TDSFoot'
    import Analytics from '../util/analytics'

    export default {
        name: 'BaseVue',
        components: {
            // eslint-disable-next-line
            TDSHead,
            // eslint-disable-next-line
            TDSFoot
        },
        computed: {
            url() {
                return this.$store.getters.url
            }, logged() {
                return this.$store.getters.logged
            }, admin() {
                return this.$store.getters.admin
            }, enow() {
                return this.$store.getters.enow_url
          }
        },
        methods: {
            getEnow: async function(params,loading) {
              return ""; //this.get(params,loading,this.$store.getters.tds_api+'/'+this.$store.getters.token)
            },
            get: async function (params, loading, base) {
                try {
                    if (typeof loading === 'undefined') loading = false

                    if (loading) this.$store.commit('loading', true)
                    if (!base) base = this.$store.getters.url

                    if (Array.isArray(params)) {
                        let req = []
                        for (let i = 0; i < params.length; i++)
                            req.push(this.$http.get(base + params[i]))


                        let data = await this.$http.all(req)

                        let ret = []
                        for (let i = 0; i < data.length; i++)
                            ret.push(data[i].data)

                        return Promise.resolve(ret)
                    } else {
                        let result = await this.$http.get(base + params)
                        if (loading) this.$store.commit('loading', false)
                        // Invalid token
                        if (result.data.Status && result.data.Status.Code === 9) {
                            // Se il token è sbagliato, cancello il token
                            this.$store.commit('user', null)
                            // Faccio il refresh della pagina
                            window.location.reload()
                        }
                        return Promise.resolve(result.data)
                    }


                } catch (error) {
                    this.$notify({type: 'alert-info', text: this.$t('errors.loading')})
                    // eslint-disable-next-line
                    console.log(error)
                    return Promise.resolve(false)
                }
            }, error(text) {
                this.$notify({type: 'alert-info', text: text})
            }, data_format(value) {
                if (value === null) return ''

                value = this._applyAt(value, 2, '-')
                value = this._applyAt(value, 5, '-')
                return value
            }, _applyAt(value, pos, divider) {
                let first = ''
                let last = ''

                if (value.length > pos) {
                    if (value[pos] !== divider) {
                        if (this.isNumeric(value[pos])) {
                            first = value.substr(0, pos)
                            last = value.substr(pos)
                            value = first + divider + last
                        } else {
                            first = value.substr(0, pos)
                            last = value.substr(pos + 1)
                            value = first + divider + last
                        }
                    }
                }
                return value
            }, isNumeric(s) {
                return !isNaN(s - parseFloat(s))
            }, isDisabled(val) { // Home
                if (val === 0) return true
                return false
            }, isActive(val) { // Classifica, Streaming
                if (val === 2) return true // available and active and event date is in the future
                if (val === 12) return true // available and active and event date is today
                if (val === 22) return true // available and active and event date is in the past
                return false
            }, isComing(val) {
                if (val === 1) return true // available but not active yet and event date is in the future
                if (val === 11) return true // available but not active and event date is today
                return false
            }, isEnabled(val) {
                if (val === 2) return true // available and active and event date is in the future
                if (val === 11) return true // available but not active and event date is today
                if (val === 12) return true // available and active and event date is in today
                if (val === 22) return true // available and active and event date is in the past
                return false
            }, isAvailable(val) {
                if (val > 0) return true
                return false
            }, isToday(val) { // Classifica, Streaming
                if (val === 11) return true // available but not active and event date is today
                return false
            }, isActiveForFuture(val) { // VerificaIscrizioni, ListaIscritti
                if (val === 2) return true // available and active and event date is in the future
                if (val === 12) return true // available and active and event date is today
                return false
            }, isAvailableForFuture(val) { // Classifica, Streaming
                if (val === 1) return true // available but not active yet and event date is in the future
                if (val === 2) return true // available and active and event date is in the future
                return false
            }, isActiveAndInThePast(val) { // Diploma, Foto
                if (val === 12) return true // available and active and event date is today
                if (val === 22) return true // available and active and event date is in the past
                if (val === 21) return true // available but not active and event date is in the past ( è un caso che non dovrebbe esistere, ma magari per qualche motivo gli mancano delle info e quindi nonostante sia previsto etc, non è ancora attivo )
                return false
            }, isPast(val) {
                if (val === 22) return true // available and active and event date is in the past
                if (val === 21) return true // available but not active and event date is in the past ( è un caso che non dovrebbe esistere, ma magari per qualche motivo gli mancano delle info e quindi nonostante sia previsto etc, non è ancora attivo )
                return false
            }, isInactive(val) {
                if (val === 11) return true // available but not active and event date is today
                if (val === 1) return true // available but not active yet and event date is in the future
                return false
            }, isActiveForPastAndToday(val) {
                if (val === 12) return true // available and active and event date is today
                if (val === 22) return true // available and active and event date is in the past
                return false
            }, isInactiveInTheFuture(val) {
                if (val === 21) return true // available but not active and event date is in the past ( è un caso che non dovrebbe esistere, ma magari per qualche motivo gli mancano delle info e quindi nonostante sia previsto etc, non è ancora attivo )
                return false
            }, tMobile(desktop, mobile) {
                if (this.isMobile())
                    return this.$t(mobile)
                return this.$t(desktop)
            }, isMobile() {
                return window.innerWidth < 768
            }, track(action, category, label, detail) {
                Analytics.track(action, category, label, detail);
            }
        }, filters: {
            sport: function (value) {

                let sports = i18n.t('sports')
                for (const key in sports) {
                    let sport = sports[key]
                    if (sport.value == value)
                        return sport.text
                }
                return '?'
            }
        },
    }
</script>

<style scoped>

</style>
